module.exports = __webpack_public_path__ + "static/media/LR3.0ac75a99.jpg";